import { useTranslation } from 'react-i18next';

export function useTitleController() {
  const { t } = useTranslation();

  const titleText = t('charity.about.title');

  return { titleText };
}
